import "./App.css";
import { LandingPage } from "./pages";

function App() {
  return <LandingPage />;
}

export default App;
